export const TEST_ID = 'maintenancePage';

export const DEFAULT_PHASE = 6;

export const DEFAULT_VIEW = 'drones' as const;

export const MAINTENANCE_VIEWS = ['drones', 'batteries'] as const;

export const PHASE_USAGE = 2;

export const PHASE_FIRMWARE = 3;

export const PHASE_HEALTH_FAULTS = 4;

export const PHASE_CALIBRATION = 5;

export const PHASE_ORDERING = 6;

export const RING_CIRCUMFERENCE = 150.8;

export const RING_CAUTION_PERCENT = 80;

export const RING_CRITICAL_PERCENT = 100;

export const DUE_SOON_PERCENT = 80;

export const RING_MAX_PERCENT = 100;

export const SPARKLINE_WIDTH = 300;

export const SPARKLINE_HEIGHT = 28;

export const DRAWER_TABS = ['health', 'components', 'service', 'parts', 'warnings'] as const;

export const FILTER_KEYS = ['all', 'critical', 'caution', 'dueSoon', 'grounded'] as const;

export const RING_PARTS = ['motor', 'propSet', 'pumpSealKit'] as const;

export const DEFAULT_AIRCRAFT_MODEL = 'exedyV9' as const;

export const AIRCRAFT_MODEL_IDS = ['exedyV9', 'exedyV12'] as const;

export const INTERVAL_PARTS = [
    'motor',
    'propSet',
    'pumpSealKit',
    'nozzleSet',
    'battery',
    'esc',
    'rtkAntenna',
    'flowMeter'
] as const;

export const COMPARABLE_FIRMWARE = ['fc', 'pump'] as const;

export const INTERVAL_INPUT_MIN = 1;

export const INTERVAL_INPUT_MAX = 100000;

export const INTERVAL_INPUT_STEP = 10;

export const PART_PRICE = {
    battery: 820,
    esc: 245,
    flowMeter: 195,
    motor: 485,
    nozzleSet: 110,
    propSet: 140,
    pumpSealKit: 68,
    rtkAntenna: 320
} as const;

export const RECOMMEND_THRESHOLD = 0.8;

export const ORDER_SUCCESS_DURATION_MS = 2000;

export const MOCK_CURRENT_USER = 'You';

export const AIRWORTHY_STATUSES = ['ready', 'hold', 'grounded'] as const;

export const BATTERY_LIFECYCLE_STATUSES = ['in-service', 'hold', 'retired'] as const;

export const PHASE_BATTERY_ELECTRICALS = 4;

// Default battery-drawer tab. The Component agent defines the battery TabKey union; this
// literal must remain the first tab in that union so the drawer opens on it.
export const DEFAULT_BATTERY_TAB = 'overview';
